import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/TechnicianLogin.css'; // we'll create this next

function RoleSelection() {
  const navigate = useNavigate();

const handleTechnicianLogin = () => {
  navigate('/technician/signin', { state: { role: 'technician' } });
};

const handleHirerLogin = () => {
  navigate('/hirer/signin', { state: { role: 'hirer' } });
};

  const handleTechnicianRegister = () => {
    // This will eventually go to the technician registration page
    navigate('/technician/register');
  };

  const handleHirerRegister = () => {
    navigate('/hirer/register');
  };

  return (
    <div className="login-container">
      <div className="button-group">
        <button className="role-button" onClick={handleTechnicianLogin}>
          Technician
        </button>
        <p className="register-link">
          New technician?{' '}
          <span onClick={handleTechnicianRegister} className="link">
            Register
          </span>
        </p>
      </div>

      <div className="button-group">
        <button className="role-button" onClick={handleHirerLogin}>
          Hirer
        </button>
        <p className="register-link">
          New hirer?{' '}
          <span onClick={handleHirerRegister} className="link">
            Register
          </span>
        </p>
      </div>
    </div>
  );
}

export default RoleSelection;